import { useNavigate } from 'react-router-dom';

import { verifyInvoicePatient } from 'api/Public';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

export const useVerifyInvoicePatient = ({ onSuccess } = {}) => {
  const navigate = useNavigate();

  return useCustomMutation({
    mutationFn: (values) => verifyInvoicePatient(navigate, values),
    successMessage: 'Details verified',
    onSuccess
  });
};
